/**
 * Layout e animações da landing pública, derivados de `docs/design/prototype/Landing v2.dc.html`
 * (heroFocus='Conversa ao vivo', motionLevel='Cinemático'). As CORES do hero migraram para a
 * identidade da marca-mãe Codout (ver `brand.ts`); o antigo `heroTheme` (Noturno) foi removido.
 * As paletas das demais seções continuam em `palette.ts`.
 */

/** Grid do hero com heroFocus='Conversa ao vivo' (nao e o layout centralizado de "Só a promessa"). */
export const heroLayout = {
  gridTemplateColumns: 'repeat(auto-fit,minmax(340px,1fr))',
  textAlign: 'left',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
} as const

/** Strings de `animation` resolvidas para motionLevel='Cinemático' (todas as animacoes ativas). */
export const anim = {
  fade: 'fadeUp 0.8s ease-out both',
  blob1: 'auroraA 26s ease-in-out infinite',
  blob2: 'auroraB 32s ease-in-out infinite',
  blob3: 'auroraA 38s ease-in-out infinite',
  float: 'floatY 9s ease-in-out infinite',
  sweep: 'sweep 3.4s ease-in-out infinite',
  pulseSlow: 'pulseDot 2.4s ease-in-out infinite',
  dot1: 'pulseDot 1.4s ease-in-out infinite',
  dot2: 'pulseDot 1.4s ease-in-out 0.2s infinite',
  dot3: 'pulseDot 1.4s ease-in-out 0.4s infinite',
  ask: 'beatAsk 9s cubic-bezier(0.2,0.7,0.2,1) infinite',
  typing: 'beatTyping 9s ease-in-out infinite',
  suggestion: 'beatSuggestion 9s cubic-bezier(0.2,0.7,0.2,1) infinite',
  approved: 'beatApproved 9s cubic-bezier(0.2,0.7,0.2,1) infinite',
  replies: 'beatReplies 9s cubic-bezier(0.2,0.7,0.2,1) infinite',
  blink1: 'blinkDot 1.2s ease-in-out infinite',
  blink2: 'blinkDot 1.2s ease-in-out 0.2s infinite',
  blink3: 'blinkDot 1.2s ease-in-out 0.4s infinite',
  blobControle: 'auroraB 30s ease-in-out infinite',
  blobCta: 'auroraA 28s ease-in-out infinite',
} as const
